<!-- multi-select-calendar.component.html -->
<div class="calendar-container">
	<div class="month-navigation">
		<button class="btn" (click)="toggleMonth(-1)" [disabled]="disableBackButton" aria-label="Mese precedente">
			<app-icon name="it-chevron-left" color="white"></app-icon>
		</button>
		<h6 class="m-0">{{ months[currentDate.getMonth()] }} {{ currentDate.getFullYear() }}</h6>
		<button class="btn" (click)="toggleMonth(1)" [disabled]="disableNextButton" aria-label="Mese successivo">
			<app-icon name="it-chevron-right" color="white"></app-icon>
		</button>
	</div>
	<div class="calendar">
		<div class="weekdays">
			@for (day of ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom']; track $index) {
				<div class="weekday">
					{{ day }}
				</div>
			}
		</div>
		<div class="days">
			@for (day of getDaysArray(currentDate.getFullYear(), currentDate.getMonth()); track $index) {
				@if (day == 0) {
					<div class="day empty"></div>
				} @else {
					<div
						class="day"
						tabindex="0"
						[class.selected]="
							isDateSelected(createDate(currentDate.getFullYear(), currentDate.getMonth(), day))
						"
						(click)="selectDate(createDate(currentDate.getFullYear(), currentDate.getMonth(), day))"
						(keydown.enter)="selectDate(createDate(currentDate.getFullYear(), currentDate.getMonth(), day))"
						[attr.aria-label]="
							'Giorno ' + day + '-' + currentDate.getMonth() + '-' + currentDate.getFullYear()
						"
						[attr.aria-selected]="
							isDateSelected(createDate(currentDate.getFullYear(), currentDate.getMonth(), day))
								? true
								: false
						">
						{{ day }}
					</div>
				}
			}
		</div>
	</div>
	<p tabindex="0" aria-live="polite">
		Valori selezionati: {{ this.selectedDates.length }} (max. {{ this.specificConfig.selectionLimit }})
		<app-info-button modalId="selectedDatesModal" title="Visualizza valori selezionati."></app-info-button>
	</p>
</div>

<app-modal modalId="selectedDatesModal" [modal]="this.selectedDatesModal"></app-modal>
